import { render } from "./DeptChairComplianceChecking.vue?vue&type=template&id=7f0e0fd8"
import script from "./DeptChairComplianceChecking.vue?vue&type=script&lang=js"
export * from "./DeptChairComplianceChecking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__